export default __webpack_public_path__ + "static/shareplay-8a8e305c6ed6ad0bcfa8db9691feed71.png";